import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffSelectMultipleUserEmailField from "../components/finalForm/inputs/RffSelectMultipleUserEmailField";
import RffSelectUserEmailField from "../components/finalForm/inputs/RffSelectUserEmailField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";

const EditBorrowerProfilePermittedUsers = ({
  borrowerId,
  initialValues,
  onSuccessFn,
}) => {
  const { loading, updateBorrowerProfile } = useBorrowerPortalHook();

  const onUpdate = (formData) => {
    // console.log("onUpdate", {
    //   entityId: initialValues?._id,
    //   data: formData,
    //   onSuccessFn,
    // });
    // return;
    updateBorrowerProfile({
      _id: borrowerId,
      entityId: initialValues?._id,
      data: formData,
      onSuccessFn: onSuccessFn,
    });
  };

  return (
    <CreateEditForm
      onUpdate={onUpdate}
      loading={loading}
      initialValues={initialValues}
      updateButtonText="Update Permitted Users"
    >
      <BorrowerProfileFormQuestions isEditing />
    </CreateEditForm>
  );
};

const BorrowerProfileFormQuestions = ({ isEditing }) => {
  return (
    <>
      <RffGroup groupLabel="Current Permitted Users">
        {/* <RffSelectUserEmailField name="permittedUsers" /> */}
        <RffSelectMultipleUserEmailField name="permittedUsers" />
      </RffGroup>
    </>
  );
};
export default EditBorrowerProfilePermittedUsers;
